module.exports = "<label class=\"label-acordion\">{{ titulo | uppercase }}</label>\n<ng-container #acordionContainer>\n\n</ng-container>"